<template>
  <div class="footer">
    <p style="padding-top: 18px">
      <!--Copyright©成都智博智伴-->
      <!-- Copyright©上海企苗企业管理咨询有限公司 -->
    </p>
  </div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
.footer {
  
  height: 80px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  box-sizing: border-box;
  background: linear-gradient(
    165deg,
    rgba(48, 145, 224, 1),
    rgba(18, 105, 194, 1)
  );
  line-height: 38px;
  text-align: center;
  color: #fff;
  font-size: 12px;
  color: rgba(255, 255, 255, 1);
  img {
    vertical-align: -2px;
    margin-right: 5px;
    width: 14px;
    height: 14px;
  }
}
</style>
